import React from 'react'
import { Link, useLocation } from 'react-router-dom'

import openLink from '../../icons/quick_reference_all.svg'
import styled from 'styled-components'
import { useI18nFunction } from '../I18n'

const OpenForm = ({ onClick }) => {
    const I18nFunction = useI18nFunction()
    const location = useLocation()

    return (
        <FormLinkWrapper title={I18nFunction({ id: "Open" })} button onClick={onClick}>
            <FormLink to={location.pathname}>
                <Open src={openLink} />
            </FormLink>
        </FormLinkWrapper>
    )
}

const Open = styled.img`
height: 2em;
`
export const FormLink = styled(Link)`
  padding: 0.7em;
  text-decoration: none;
  }
`
const FormLinkWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 5px;
  z-index:1;
  cursor: ${({ button }) => button ? 'pointer' : 'inherit'};
    &:hover {
    background-color: ${({ theme, button }) => button ? theme.listItemHover : 'inherit'};
`
export default OpenForm